import React from 'react';
import {Modal} from 'antd';
import {FilePreview} from '../FilePreview';
import {getFileName} from '../../utils/filePreview';
import './index.scss';

export function PreviewModal({open, file, url, onCancel}: any) {
  return (
    <Modal
      className="drive-preview-modal"
      title={getFileName(file) || '文件预览'}
      visible={open}
      onCancel={onCancel}
      footer={null}
      width="86vw"
      destroyOnClose
    >
      <FilePreview file={file} url={url}/>
    </Modal>
  );
}